module.exports = __webpack_public_path__ + "img/read.b52e4541.png";